import { FC, useCallback, useEffect, useMemo, useState } from "react";
import Modal from "../../Modal";

import Method from "./Method";
import HowToUse from "./HowToUse";
import { useMediaQuery } from "@mui/material";
import Button from "../../Button";

import styles from "./styles.module.scss";
import { Select } from "../../OldSelect";
import { CrossIcon } from "../../../assets/img/icons";

type Props = {
    open: boolean;
    onClose: () => void;
};

const TradingMethodModal: FC<Props> = ({ open, onClose }) => {
    const isMobile = useMediaQuery("(max-width: 1050px)");

    const tabs = [
        { label: "Méthode", key: "method" },
        { label: "Comment utiliser ?", key: "howToUse" },
    ];

    const [activeTab, setActiveTab] = useState("method");

    const handleTabChange = useCallback((key: string) => {
        setActiveTab(key);
    }, []);

    const renderTabContent = useMemo(() => {
        switch (activeTab) {
            case "method":
                return <Method />;
            case "howToUse":
                return <HowToUse />;
            default:
                return null;
        }
    }, [activeTab]);

    useEffect(() => {
        if (!open) {
            setActiveTab("method");
        }
    }, [open]);

    return (
        <Modal
            open={open}
            onClose={onClose}
            size="medium"
            className={styles.container}
        >
            {isMobile && (
                <div className={styles.header}>
                    <Select
                        className={styles.selectTab}
                        onChanged={(value) => handleTabChange(value as string)}
                    >
                        <option value="method">Méthode</option>
                        <option value="howToUse">Comment utiliser ?</option>
                    </Select>
                    <CrossIcon
                        className="confirmModal_header_close"
                        onClick={onClose}
                    />
                </div>
            )}
            <div className={styles.body}>
                {!isMobile && (
                    <div className={styles.tabs}>
                        {tabs.map((tab) => (
                            <Button
                                key={tab.key}
                                variant={
                                    activeTab === tab.key
                                        ? "secondary"
                                        : "transparent"
                                }
                                size="medium"
                                labelOptions={{ align: "left" }}
                                className={styles.tab}
                                onClick={() => handleTabChange(tab.key)}
                                label={tab.label}
                            />
                        ))}
                    </div>
                )}
                {!isMobile && <div className={styles.divider} />}
                <div className={styles.tab_content}>{renderTabContent}</div>
            </div>
        </Modal>
    );
};

export default TradingMethodModal;
